import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";

import DispatchTableEmployee from "./EmployeeTable";
import DispatchTableNote from "./NoteTable";
import DispatchTableVehicles from "./VehiclesTable";
import DispatchTableCaptain from "./CaptainTable";
import DispatchTableJobs from "./JobsTable";

import {
  selectTeamEmployees,
  selectTeamToolboxes,
  selectTeamJobs,
  selectTeamTrucks,
  selectEmployee,
} from "../../Containers/Dispatch/selectors";
import {
  toggleItemModal,
  openMainModal,
  closeMainModal,
} from "../../Redux/UI/actions";
import TimePicker from "../Select/TimePicker";
import {
  deleteDispatch,
  updateListItemFromDispatch,
  updateItemFromDispatch,
  copyItem,
  pasteItem,
  updateTeamJob,
  reorderJobs,
  addCopyTeams,
  deleteJobs,
  addJobs,
  fetchDispatch,
} from "../../Containers/Dispatch/actions";
import TeamSettings from "../Modals/TeamSettings";
import JobForm from "../Modals/JobForm";

class DispatchItem extends Component {
  modalContent = () => {
    const {
      userType,
      team: { title },
    } = this.props;

    if (userType !== "admin") {
      return null;
    }

    return (
      <TeamSettings
        ref={(teamSettings) => {
          this.teamSettings = teamSettings;
        }}
        title={title}
      />
    );
  };

  jobModalContent = (job) => {
    const { userType } = this.props;

    return (
      <JobForm
        ref={(jobForm) => {
          this.jobForm = jobForm;
        }}
        userType={userType}
        job={job}
      />
    );
  };

  handleOpenJobModal = (job) => {
    const { onOpenMainModal, userType } = this.props;
    onOpenMainModal(
      this.jobModalContent(job),
      "Détail Job",
      this.handleCloseJobModal,
      userType === "admin" ? "SAUVEGARDER" : "OK"
    );
  };

  handleCloseJobModal = () => {
    const { onUpdateTeamJob, userType } = this.props;
    const { job } = this.jobForm.state;

    if (userType === "admin") {
      onUpdateTeamJob(job);
    }
  };

  handleOpenModal = () => {
    const { onOpenMainModal } = this.props;
    onOpenMainModal(this.modalContent(), "Options", this.handleCloseModal);
  };

  handleDeleteModal = (teamID, teamTitle, date, index) => {
    const { onOpenMainModal, onDeleteDispatch } = this.props;
    onOpenMainModal(
      `Voulez-vous vraiment supprimer ${teamTitle} ?`,
      "SUPPRESSION",
      () => onDeleteDispatch(teamID, date, index),
      "CONFIRMER",
      null,
      "ANNULER"
    );
  };

  handleVisibility = () => {
    const { onUpdateItemFromDispatch, team } = this.props;
    onUpdateItemFromDispatch(team.id, "visible", !team.visible);
  };

  handleCloseModal = () => {
    const { onUpdateItemFromDispatch, team } = this.props;
    onUpdateItemFromDispatch(team.id, "title", this.teamSettings.state.title);
  };

  handlePaste(teamID, copyPayload, fromTeamID) {
    const { teams, onAddJobs } = this.props;
    const team = teams[teamID];
    const jobsToAdd = teams[fromTeamID].jobs;
    if (team.jobs.length + jobsToAdd.length <= 8) {
      onAddJobs(teamID, jobsToAdd, fromTeamID);
    }
  }

  handleOpenItemModal = (itemModalContent) => {
    const { onOpenMainModal } = this.props;
    onOpenMainModal(itemModalContent, "Détails");
  };

  handleCloseItemModal = () => {
    const { onCloseMainModal } = this.props;
    onCloseMainModal();
  };

  render() {
    const {
      team,
      employees,
      toolboxes,
      trucks,
      jobs,
      captain,
      onToggleItemModal,
      onDeleteDispatch,
      onUpdateListItemFromDispatch,
      onUpdateItemFromDispatch,
      onCopyItem,
      onPasteItem,
      copyType,
      onReorderJobs,
      onAddCopyTeams,
      copyPayload,
      onDeleteJobs,
      date,
      fromTeamID,
      userType,
      username,
    } = this.props;

    const captainNo = captain ? captain.employee_number : 0;
    const isTeamCaptain = captainNo === Number.parseInt(username);
    const className = isTeamCaptain
      ? "dispatch-item orange-team"
      : "dispatch-item";

    return (
      <li className={className}>
        <div className="content-box">
          {/* do not change content-box-header-container class */}
          <div className="content-box-header-container">
            {userType === "admin" ? (
              <TimePicker
                value={team.hour}
                handleChange={(e) =>
                  onUpdateItemFromDispatch(team.id, "hour", e)
                }
              />
            ) : (
              <span>{team.hour}</span>
            )}

            <h3 className="content-box-header">{team.title}</h3>

            <div className="print-date">{date}</div>

            {userType === "admin" && (
              <div className="header-settings">
                <i
                  onClick={this.handleOpenModal}
                  className="fa fa-cog edit"
                  aria-hidden="true"
                />
                <i
                  onClick={this.handleVisibility}
                  className={
                    team.visible ? "fa fa-eye" : "fa fa-eye-slash danger_icon"
                  }
                  aria-hidden="true"
                />
                <i
                  className={
                    copyType === "teams" && copyPayload[team.id]
                      ? "select_icon fa copy-icon teams fa-files-o"
                      : "fa copy-icon teams fa-files-o"
                  }
                  aria-hidden="true"
                  onClick={() => onAddCopyTeams(team)}
                />
                <i
                  className="fa fa-times delete-icon"
                  aria-hidden="true"
                  onClick={() =>
                    this.handleDeleteModal(
                      team.id,
                      team.title,
                      team.date,
                      team.index
                    )
                  }
                />
              </div>
            )}
          </div>
          <div className="content-box-wrapper">
            <div className="left">
              <DispatchTableCaptain
                captain={captain}
                handleToggleItemModal={(index) =>
                  onToggleItemModal(index, team.id)
                }
                handleDeleteClick={() =>
                  onUpdateItemFromDispatch(team.id, "captain_id", null)
                }
                handleCopy={() => onCopyItem("captain_id", team.captain_id)}
                handlePaste={() => onPasteItem(team.id)}
                handleOpenItemModal={this.handleOpenItemModal}
                handleCloseItemModal={this.handleCloseItemModal}
                copyType={copyType}
                userType={userType}
              />
              <DispatchTableVehicles
                trucks={trucks}
                toolboxes={toolboxes}
                handleToggleItemModal={(index) =>
                  onToggleItemModal(index, team.id)
                }
                handleDeleteClick={(item, type) =>
                  onUpdateListItemFromDispatch(team.id, type, item)
                }
                handleCopy={() =>
                  onCopyItem("trucksAndToolboxes", {
                    trucks: team.trucks,
                    toolboxes: team.toolboxes,
                  })
                }
                handlePaste={() => onPasteItem(team.id)}
                handleOpenItemModal={this.handleOpenItemModal}
                handleCloseItemModal={this.handleCloseItemModal}
                copyType={copyType}
                userType={userType}
              />
              <DispatchTableNote
                note={team.note}
                handleToggleItemModal={(index) =>
                  onToggleItemModal(index, team.id)
                }
                handleDeleteClick={() =>
                  onUpdateItemFromDispatch(team.id, "note", "")
                }
                handleCopy={() => onCopyItem("note", team.note)}
                handlePaste={() => onPasteItem(team.id)}
                handleOpenItemModal={this.handleOpenItemModal}
                handleCloseItemModal={this.handleCloseItemModal}
                copyType={copyType}
                userType={userType}
              />
            </div>
            <DispatchTableEmployee
              employees={employees}
              handleToggleItemModal={(index) =>
                onToggleItemModal(index, team.id)
              }
              handleDeleteClick={(item) =>
                onUpdateListItemFromDispatch(team.id, "employees", item)
              }
              handleCopy={() => onCopyItem("employees", team.employees)}
              handlePaste={() => onPasteItem(team.id)}
              handleOpenItemModal={this.handleOpenItemModal}
              handleCloseItemModal={this.handleCloseItemModal}
              copyType={copyType}
              userType={userType}
            />
            <div className="bottom ">
              <DispatchTableJobs
                jobs={jobs}
                handleToggleItemModal={(index) =>
                  onToggleItemModal(index, team.id)
                }
                handleDeleteClick={(item, itemIndex) =>
                  onDeleteJobs(team.id, [item], itemIndex)
                }
                handleCopy={(fromTeamID) =>
                  onCopyItem("jobs", team.tmp_jobs_ids, fromTeamID)
                }
                handlePaste={() => {
                  this.handlePaste(team.id, copyPayload, fromTeamID);
                }}
                copyType={copyType}
                teamID={team.id}
                handleOpenModal={this.handleOpenJobModal}
                handleReorderJobs={onReorderJobs}
                userType={userType}
                isTeamCaptain={isTeamCaptain}
                captainNo={captainNo}
                employees={employees}
                trucks={trucks}
                toolboxes={toolboxes}
              />
            </div>
          </div>
        </div>
      </li>
    );
  }
}

DispatchItem.defaultProps = {
  userType: "",
};

DispatchItem.propTypes = {
  team: PropTypes.object,
  employees: PropTypes.array,
  toolboxes: PropTypes.array,
  trucks: PropTypes.array,
  jobs: PropTypes.array,
  onToggleItemModal: PropTypes.func,
  onFetchDispatch: PropTypes.func,
  onDeleteDispatch: PropTypes.func,
  onUpdateListItemFromDispatch: PropTypes.func,
  onReorderJobs: PropTypes.func,
  onAddCopyTeams: PropTypes.func,
  date: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  employees: selectTeamEmployees(state, ownProps.team.employees),
  toolboxes: selectTeamToolboxes(state, ownProps.team.toolboxes),
  trucks: selectTeamTrucks(state, ownProps.team.trucks),
  jobs: selectTeamJobs(state, ownProps.team.jobs),
  teams: state.dispatch.teams,
  captain: selectEmployee(state, ownProps.team.captain_id),
  copyType: state.dispatch.copyType,
  copyPayload: state.dispatch.copyPayload,
  date: state.dispatch.date,
  fromTeamID: state.dispatch.fromTeamID,
  userType: state.auth.user.userType,
  username: state.auth.user.username,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onFetchDispatch: (date) => dispatch(fetchDispatch(date)),
  onToggleItemModal: (index, activeTeamID) =>
    dispatch(toggleItemModal(index, activeTeamID)),
  onDeleteDispatch: (id, date, index) =>
    dispatch(deleteDispatch(id, date, index)),
  onUpdateListItemFromDispatch: (teamID, listKey, itemID, value) =>
    dispatch(updateListItemFromDispatch(teamID, listKey, itemID, value)),
  onUpdateItemFromDispatch: (teamID, key, value) =>
    dispatch(updateItemFromDispatch(teamID, key, value)),
  onCopyItem: (type, payload, fromTeamID) =>
    dispatch(copyItem(type, payload, fromTeamID)),
  onPasteItem: (teamID, fromTeamID) => dispatch(pasteItem(teamID, fromTeamID)),
  onUpdateTeamJob: (job) => dispatch(updateTeamJob(job)),
  onReorderJobs: (teamID, startIndex, endIndex) =>
    dispatch(reorderJobs(teamID, startIndex, endIndex)),
  onAddCopyTeams: (team) => dispatch(addCopyTeams(team)),
  onDeleteJobs: (teamID, jobsToRemove, jobIndex) =>
    dispatch(deleteJobs(teamID, jobsToRemove, jobIndex)),
  onAddJobs: (teamID, jobsToAdd, fromTeamID) =>
    dispatch(addJobs(teamID, jobsToAdd, fromTeamID)),
  onOpenMainModal: (
    content,
    title,
    closeCB,
    btnLabel,
    btnSecondaryCb,
    btnSecondaryLabel
  ) =>
    dispatch(
      openMainModal(
        content,
        title,
        closeCB,
        btnLabel,
        btnSecondaryCb,
        btnSecondaryLabel
      )
    ),
  onCloseMainModal: () => dispatch(closeMainModal()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(DispatchItem);
